import { render, staticRenderFns } from "./TextScroll.vue?vue&type=template&id=2072425c&scoped=true"
import script from "./TextScroll.vue?vue&type=script&lang=js"
export * from "./TextScroll.vue?vue&type=script&lang=js"
import style0 from "./TextScroll.vue?vue&type=style&index=0&id=2072425c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2072425c",
  null
  
)

export default component.exports